import { footerTheme as footerThemeSemiDark } from 'themes/jumbo/app/_themes/footer/semi-dark';
import { footerTheme as footerThemeDark } from 'themes/jumbo/app/_themes/footer/dark';
import { footerTheme as footerThemeDefault } from 'themes/jumbo/app/_themes/footer/default';

import { headerTheme as headerThemeDark } from 'themes/jumbo/app/_themes/header/dark';
import { headerTheme as headerThemeDefault } from 'themes/jumbo/app/_themes/header/default';
import { headerTheme as headerThemeSemiDark } from 'themes/jumbo/app/_themes/header/semi-dark';

import { sidebarTheme as sidebarThemeSemiDark } from 'themes/jumbo/app/_themes/sidebar/semi-dark';
import { sidebarTheme as sidebarThemeDark } from 'themes/jumbo/app/_themes/sidebar/dark';
import { sidebarTheme as sidebarThemeDefault } from 'themes/jumbo/app/_themes/sidebar/default';

import { mainTheme as mainThemeSemiDark } from 'themes/jumbo/app/_themes/main/semi-dark';
import { mainTheme as mainThemeDark } from 'themes/jumbo/app/_themes/main/dark';
import { mainTheme as mainThemeDefault } from 'themes/jumbo/app/_themes/main/default';

import { JumboIconButton } from 'themes/jumbo/@jumbo/components/JumboIconButton';

import {
	useJumboFooterTheme,
	useJumboHeaderTheme,
	useJumboSidebarTheme,
	useJumboTheme,
} from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';

import { Span } from 'themes/jumbo/@jumbo/shared';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { Tooltip } from "@mui/material";
import React, { useEffect } from 'react';
import { trackEvent } from 'components/Tracking';

const ThemeModeOption = () => {
	const { theme, setTheme } = useJumboTheme();
	const { setSidebarTheme } = useJumboSidebarTheme();
	const { setHeaderTheme } = useJumboHeaderTheme();
	const { setFooterTheme } = useJumboFooterTheme();

	useEffect(() => {
		if (typeof window === "undefined") return;
		if (!theme?.type) return;
		localStorage.setItem('selectedTheme', theme.type);
	}, [theme?.type]);

	const handleModeChange = React.useCallback(
    	(type: string) => {

			switch (type) {

				case 'light':
					setTheme({ type: 'light', ...mainThemeDefault });
					setHeaderTheme({ ...theme, ...headerThemeDefault });
					setSidebarTheme({ ...theme, ...sidebarThemeDefault });
					setFooterTheme({ ...theme, ...footerThemeDefault });
					return;

				case 'semi-dark':
					setTheme({ type: 'semi-dark', ...mainThemeSemiDark });
					setHeaderTheme({ ...theme, ...headerThemeSemiDark });
					setSidebarTheme({ ...theme, ...sidebarThemeSemiDark });
					setFooterTheme({ ...theme, ...footerThemeSemiDark });
					return;

				case 'dark':
					setTheme({ type: 'dark', ...mainThemeDark });
					setHeaderTheme({ ...theme, ...headerThemeDark });
					setSidebarTheme({ ...theme, ...sidebarThemeDark });
					setFooterTheme({ ...theme, ...footerThemeDark });
					return;
			}
    	},
    [theme, setTheme, setFooterTheme, setHeaderTheme, setSidebarTheme]
  	);
  	return (
    <Span>
      {/* <Tooltip title={`${theme.type} Mode`}> */}
      {theme.type === 'light' ? (
        
          <JumboIconButton
            onClick={() => {
              trackEvent("TopMenu", "Switch", "Dark Mode");
              handleModeChange('dark')}
            }
            elevation={23}
          >
            <Tooltip title="Switch to dark mode" placement="top" arrow>
              <LightModeOutlinedIcon sx={{ fontSize: '1.25rem' }} />
            </Tooltip>
          </JumboIconButton>
        
      ) : (
        
          <JumboIconButton
            onClick={() => {
              trackEvent("TopMenu", "Switch", "Light Mode");
              handleModeChange('light');
            }}
            elevation={23}
          >
            <Tooltip title="Switch to light mode" placement="top" arrow>
              <DarkModeOutlinedIcon sx={{ fontSize: '1.25rem' }} />
            </Tooltip>
          </JumboIconButton>
        
      )}
      {/* </Tooltip> */}
    </Span>
  );
};

export { ThemeModeOption };
